import { render, staticRenderFns } from "./Savannah.vue?vue&type=template&id=9928feb4"
import script from "./Savannah.vue?vue&type=script&lang=js"
export * from "./Savannah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports